<template>
  <div class="title-block">
    <div class="title-block__left">
      <div class="title-block__title">Сформировать документ</div>
    </div>
  </div>
  <div class="table-responsive mb-4">
    <div class="form-label form-label_lg">Выбранные лицензии:</div>
    <table class="table table-borderless">
      <thead>
        <tr>
          <th>Номер аптеки</th>
          <th>Клиент</th>
          <th>Адрес</th>
          <th>Организация</th>
          <th>Устройство</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>77-105</td>
          <td>Неофарм</td>
          <td>Московская область, г. Люберцы, Кастанаевская улица, 30 к1</td>
          <td>ООО «Неофарм Северо-Запад»</td>
          <td>Киоск 1</td>
          <td><button class="table-action table-action_delete" title="Удалить" type="button"></button></td>
        </tr>
        <tr>
          <td>77-105</td>
          <td>Неофарм</td>
          <td>Московская область, г. Люберцы, Кастанаевская улица, 30 к1</td>
          <td>ООО «Неофарм Северо-Запад»</td>
          <td>Киоск 1</td>
          <td><button class="table-action table-action_delete" title="Удалить" type="button"></button></td>
        </tr>
        <tr>
          <td>77-105</td>
          <td>Неофарм</td>
          <td>Московская область, г. Люберцы, Кастанаевская улица, 30 к1</td>
          <td>ООО «Неофарм Северо-Запад»</td>
          <td>Киоск 1</td>
          <td><button class="table-action table-action_delete" title="Удалить" type="button"></button></td>
        </tr>
      </tbody>
    </table>
  </div>
  <form>
    <div class="form-narrow mb-4">
      <div class="form-label form-label_lg">Выберите отчётный период</div>
      <div class="row">
        <div class="col-6">
          <div class="form-label">Дата начала</div>
          <!-- Используется вместе с иипортированным методом из js/utilites.js dateFormat -->
          <VueDatePicker v-model="date" locale="ru" :action-row="{ showSelect: false, showCancel: false }"
            :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"
            :format="dateFormat" :teleport="true">
            <template #input-icon>
              <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"
                  d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />
              </svg>
            </template>
          </VueDatePicker>
        </div>
        <div class="col-6">
          <div class="form-label">Дата окончания</div>
          <!-- Используется вместе с иипортированным методом из js/utilites.js dateFormat -->
          <VueDatePicker v-model="dateEnd" locale="ru" :action-row="{ showSelect: false, showCancel: false }"
            :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"
            :format="dateFormat" :teleport="true">
            <template #input-icon>
              <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"
                  d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />
              </svg>
            </template>
          </VueDatePicker>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column flex-md-row align-items-stretch py-3">
          <!-- Пример с модалкой открывается по кнопке сохранить -->
          <button type="button" class="btn btn-md btn-primary flex-grow-1 me-md-3 mb-3 mb-md-0">
            Сформировать
          </button>
          <a href="#" download="report" type="button"
            class="btn btn-md btn-outline-primary me-md-3 mb-3 mb-md-0 flex-grow-1">
            Скачать
          </a>
          <a href="/documents/licenses" type="button" class="btn btn-md btn-outline-dark flex-grow-1">
            Отменить
          </a>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { dateFormat } from '../../../../utilites';
export default {
  name: "CreateAccountingDocumentsReport",
  data: function () {
    return {
      date: null,
      dateEnd: null,
    };
  },
  methods: {
    dateFormat,
  }
};
</script>
